module.exports = __webpack_public_path__ + "static/media/copy_button.dac848a2.svg";